import { request } from '../../Common/api/client';

/**
 * 관리자 활동 현황 조회.
 * 공통 request가 응답 JSON의 code === 1000을 검증하고 data만 반환한다.
 */
export async function getAdminActivityLogs(filters = {}) {
  const params = new URLSearchParams();
  params.set('page', String(filters.page ?? 1));
  params.set('limit', String(filters.limit ?? 100));

  ['dateFrom', 'dateTo', 'q', 'actorType', 'activityType', 'result'].forEach((key) => {
    const value = filters[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      params.set(key, String(value).trim());
    }
  });

  return request({ method: 'GET', url: '/api/admin/activity-logs', params });
}
